/**
 * 51esc web — entry point: `/cvn-quals.html`.
 *
 * Quals & Traps (Fase 5g.3): tabla de apontajes por piloto — traps,
 * bolters, wave-offs, media LSO y distribución por cable. Consume
 * `GET /api/greenie-board` (5g.2). Se llega desde el hotspot del
 * monitor TV de la ready room (`/portaaviones.html`).
 */

import { mountCvnQuals } from './modules/cvn-quals/mount.js';

void mountCvnQuals();
